import { render } from "./EditEvent.vue?vue&type=template&id=4333f3c8&scoped=true"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"

import "./EditEvent.vue?vue&type=style&index=0&id=4333f3c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4333f3c8"]])

export default __exports__